import React from 'react';

interface IDeleteProps {
    handleClick?: any;
    color?:string;
    className?:string;
}
const DeleteIcon = ({ handleClick, color }:IDeleteProps) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={handleClick} style={{ cursor: 'pointer' }}>
    <path d="M17.5 4.98332C14.725 4.70832 11.9333 4.56665 9.15 4.56665C7.5 4.56665 5.85 4.64998 4.2 4.81665L2.5 4.98332" stroke="#D92D20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.08301 4.14175L7.26634 3.05008C7.39967 2.25841 7.49967 1.66675 8.90801 1.66675H11.0913C12.4997 1.66675 12.608 2.29175 12.733 3.05841L12.9163 4.14175" stroke="#D92D20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.7087 7.6167L15.167 16.0084C15.0753 17.3167 15.0003 18.3334 12.6753 18.3334H7.32533C5.00033 18.3334 4.92533 17.3167 4.83366 16.0084L4.29199 7.6167" stroke={color || '#D92D20'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.6084 13.75H11.3834" stroke="#D92D20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.91699 10.4167H12.0837" stroke="#D92D20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);
export default DeleteIcon;
